import apiConfig from '../api-config';
const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

export const getChatMessages = async (userId) => {
  try {
    const token = sessionStorage.getItem('authToken');
    const response = await fetch(`${api_base_url}/api/${api_key}/get/${userId}/chatMessage`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to retrieve chat backup: ${response.statusText}`);
    }

    return response.json();
  } catch (error) {
    console.error('Chat Backup Error:', error);
    throw error;
  }
};

